import { render, staticRenderFns } from "./DiseaseDetailFood.vue?vue&type=template&id=6890b06c&scoped=true"
import script from "./DiseaseDetailFood.vue?vue&type=script&lang=js"
export * from "./DiseaseDetailFood.vue?vue&type=script&lang=js"
import style0 from "./DiseaseDetailFood.vue?vue&type=style&index=0&id=6890b06c&prod&scoped=true&lang=css"
import style1 from "./DiseaseDetailFood.vue?vue&type=style&index=1&id=6890b06c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890b06c",
  null
  
)

export default component.exports